"use strict";

exports.__esModule = true;
exports.ACCESSIBLE_YELLOW = exports.ACCESSIBLE_GRAY = exports.ACCESSIBLE_RED = exports.LIGHT_BLUE = exports.MID_BLUE = exports.BLUE = exports.DARK_BLUE = exports.DEEP_BLUE = exports.LIGHT_GREEN = exports.MID_GREEN = exports.GREEN = exports.DARK_GREEN = exports.DEEP_GREEN = exports.LIGHT_YELLOW = exports.MID_YELLOW = exports.YELLOW = exports.DARK_YELLOW = exports.DEEP_YELLOW = exports.LIGHT_RED = exports.MID_RED = exports.RED = exports.DARK_RED = exports.DEEP_RED = exports.ALERT_LIGHT_GRAY = exports.ALERT_MID_GRAY = exports.ALERT_DARK_GRAY = exports.ALERT_DEEP_GRAY = exports.EMPHASIS = exports.SECONDARY = exports.PRIMARY = exports.FAINT_GRAY = exports.LIGHT_GRAY = exports.MID_GRAY = exports.GRAY = exports.DARK_GRAY = exports.DEEP_GRAY = exports.WHITE = exports.BLACK = void 0;

var _polished = require("polished");

// http://base2.appdirect.com/documentation/guidelines/colors.html
var tint = function tint(color, percentage) {
  var tintValue = 1 - percentage / 100;
  return (0, _polished.tint)(tintValue, color);
}; // core


var BLACK = '#2d2d2d';
exports.BLACK = BLACK;
var WHITE = '#ffffff'; // grays

exports.WHITE = WHITE;
var DEEP_GRAY = tint(BLACK, 12.5);
exports.DEEP_GRAY = DEEP_GRAY;
var DARK_GRAY = tint(BLACK, 32);
exports.DARK_GRAY = DARK_GRAY;
var GRAY = tint(BLACK, 75);
exports.GRAY = GRAY;
var MID_GRAY = tint(BLACK, 90);
exports.MID_GRAY = MID_GRAY;
var LIGHT_GRAY = tint(BLACK, 95);
exports.LIGHT_GRAY = LIGHT_GRAY;
var FAINT_GRAY = tint(BLACK, 97); // brand

exports.FAINT_GRAY = FAINT_GRAY;
var PRIMARY = '#006080';
exports.PRIMARY = PRIMARY;
var SECONDARY = '#009ABF';
exports.SECONDARY = SECONDARY;
var EMPHASIS = '#76BD22'; // alerts

exports.EMPHASIS = EMPHASIS;
var ALERT_DEEP_GRAY = '#5e5e5e';
exports.ALERT_DEEP_GRAY = ALERT_DEEP_GRAY;
var ALERT_DARK_GRAY = '#8c8c8c';
exports.ALERT_DARK_GRAY = ALERT_DARK_GRAY;
var ALERT_MID_GRAY = '#e6e6e6';
exports.ALERT_MID_GRAY = ALERT_MID_GRAY;
var ALERT_LIGHT_GRAY = '#f5f5f5';
exports.ALERT_LIGHT_GRAY = ALERT_LIGHT_GRAY;
var DEEP_RED = '#882531';
exports.DEEP_RED = DEEP_RED;
var DARK_RED = '#c13445';
exports.DARK_RED = DARK_RED;
var RED = '#E33D51';
exports.RED = RED;
var MID_RED = '#f0949f';
exports.MID_RED = MID_RED;
var LIGHT_RED = '#fef9fa';
exports.LIGHT_RED = LIGHT_RED;
var DEEP_YELLOW = '#88760e';
exports.DEEP_YELLOW = DEEP_YELLOW;
var DARK_YELLOW = '#b9a113';
exports.DARK_YELLOW = DARK_YELLOW;
var YELLOW = '#F1E540';
exports.YELLOW = YELLOW;
var MID_YELLOW = '#f9e053';
exports.MID_YELLOW = MID_YELLOW;
var LIGHT_YELLOW = '#fef9dd';
exports.LIGHT_YELLOW = LIGHT_YELLOW;
var DEEP_GREEN = '#477114';
exports.DEEP_GREEN = DEEP_GREEN;
var DARK_GREEN = '#64a11d';
exports.DARK_GREEN = DARK_GREEN;
var GREEN = '#76BD22';
exports.GREEN = GREEN;
var MID_GREEN = '#bbde91';
exports.MID_GREEN = MID_GREEN;
var LIGHT_GREEN = '#f4faed';
exports.LIGHT_GREEN = LIGHT_GREEN;
var DEEP_BLUE = '#005c73';
exports.DEEP_BLUE = DEEP_BLUE;
var DARK_BLUE = '#008bac';
exports.DARK_BLUE = DARK_BLUE;
var BLUE = '#009ABF';
exports.BLUE = BLUE;
var MID_BLUE = '#bfe6ef';
exports.MID_BLUE = MID_BLUE;
var LIGHT_BLUE = '#e6f5f9'; // accessible

exports.LIGHT_BLUE = LIGHT_BLUE;
var ACCESSIBLE_RED = '#FCECEE';
exports.ACCESSIBLE_RED = ACCESSIBLE_RED;
var ACCESSIBLE_GRAY = '#F9F9F9';
exports.ACCESSIBLE_GRAY = ACCESSIBLE_GRAY;
var ACCESSIBLE_YELLOW = '#FEFAE3';
exports.ACCESSIBLE_YELLOW = ACCESSIBLE_YELLOW;